// extracted by mini-css-extract-plugin
export default {"root":"BroadcastCreateDialog_root__uFx+O"};